import { TranslatePipe } from "../../pipes/translate.pipe";

export interface ReusableAlertPopupContent {
    titleKey: string;
    messageKey: string;
    primaryButtonLabelKey: string;
    secondaryButtonLabelKey: string;
}

export function getLinkedPatientLimitAlertContent(
    translatePipe: TranslatePipe,
): ReusableAlertPopupContent {
    return {
        titleKey: translatePipe.transform(
            "patient_limit_alert_title_family_limit_reached",
            "LABELS",
        ),
        messageKey: translatePipe.transform(
            "patient_limit_alert_message_limit_count",
            "LABELS",
        ),
        primaryButtonLabelKey: translatePipe.transform(
            "patient_limit_alert_btn_contactus_btn",
            "LABELS",
        ),
        secondaryButtonLabelKey: translatePipe.transform(
            "patient_limit_alert_btn_managemyfamily_btn",
            "LABELS",
        ),
    };
}
